// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"5d672c5f","116":"9f21c3dc","159":"e35a681b","451":"6353b430","589":"a4675a10","999":"5f3e5180"}[chunkId] + ".chunk.js";
};